import React from 'react';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const HeadineText = _ref => {
  let {
    title,
    text,
    className
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: `headline-text ${className}`,
    children: [/*#__PURE__*/_jsx("span", {
      className: "title",
      children: title
    }), text && /*#__PURE__*/_jsx(_Fragment, {
      children: text.map((item, index) => /*#__PURE__*/_jsx("p", {
        className: "subtitle",
        children: item
      }, index))
    })]
  });
};
export default HeadineText;